// extracted by mini-css-extract-plugin
export default {"status":"Auth_status__+iR0m","link":"Auth_link__3Taiw"};